import { render, staticRenderFns } from "./OrganizerSettingCopy.vue?vue&type=template&id=2261e022"
import script from "./OrganizerSettingCopy.vue?vue&type=script&lang=js"
export * from "./OrganizerSettingCopy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports